import { Close } from '@carbon/icons-react';
import { Button } from '@routable/gross-ds';
import React from 'react';
export const EscButton = ({ onPress }) => (React.createElement(Button, { "aria-label": "close", "data-testid": "button_x_escape", onPress: onPress, variant: "outline" },
    React.createElement(Close, null)));
